import {Component, OnInit, OnDestroy} from '@angular/core';
import {AuthService} from '../service/auth.service';
import {HttpClient} from '@angular/common/http';
import {SharedService, user_accessInterface} from '../service/shared.service';
import {DomSanitizer} from '@angular/platform-browser';
import {environment} from 'src/environments/environment';
import {Subject, Subscription} from 'rxjs';
import {debounceTime, switchMap, tap, catchError} from 'rxjs/operators';
import {of} from 'rxjs';


@Component({
    selector: 'app-reflections',
    templateUrl: './reflections.component.html',
    styleUrls: ['./reflections.component.css']
})
export class ReflectionsComponent implements OnInit, OnDestroy {
    reflections: any[] = [];
    token: string;
    serviceslug: string;
    sortedReflection: any[] = [];
    imgurl = environment.imageurl;

    // Debounced save per reflection
    private saveSubjects: { [key: number]: Subject<any> } = {};
    private saveSubscriptions: Subscription[] = [];
    saveStatuses: { [key: number]: string } = {};
    private savedTimeouts: { [key: number]: any } = {};
    private retryTimeouts: { [key: number]: any } = {};
    private retryCounts: { [key: number]: number } = {};
    private dirtyRefs: { [key: number]: any } = {};
    private static MAX_RETRIES = 3;

    //user access
    useraccess: user_accessInterface = {
        isaddnote: "",
        isaddreflection: "",
        islivebookserviceaccess: "",
        isprofnotesshowlivebook: "",
        isprogram: "",
        isroleid: "",
        isuploadassignments: "",
        isworkshop: "",
        view_notes: ""
    }
    isAllowed: any;
    introduction: any;
    image: any;

    constructor(public authservice: AuthService, private httpclient: HttpClient, private shared: SharedService, private domSanitizer: DomSanitizer) {
        this.image = localStorage.getItem('overview_image');
    }

    ngOnInit() {
        this.authservice.hideshowheader(false);
        this.token = localStorage.getItem('auth-token')
        this.serviceslug = localStorage.getItem('library')
        //Reflections

        this.getReflection()
    }

    onlyUnique(value, index, self) {
        return self.indexOf(value) === index;
    }

    //reflection
    getReflection() {
        this.httpclient.get(this.shared.api + "auth/all_service_reflections?token=" + this.token + "&service_slug=" + this.serviceslug).subscribe((data: reflection_interface) => {
            this.reflections = data.data;
            this.sortedReflection = [];
            let unique_name = [];
            let m_name = "";
            for (let i = 0; i < this.reflections.length; i++) {
                m_name = this.reflections[i].module_name;

                if (unique_name.includes(m_name)) {
                    this.reflections[i].module_name = '';
                } else {
                    unique_name.push(m_name);
                }
                this.sortedReflection.push(this.reflections[i]);
            }
            console.log(this.sortedReflection);


            this.httpclient.get(this.shared.api + 'auth/access_rights?token=' + this.token + "&slug=" + this.serviceslug).subscribe((data: userroalaccess) => {
                let user_access = data.role;
                this.useraccess.isaddnote = user_access['0'].add_notes
                this.useraccess.isaddreflection = user_access['0'].add_reflections
                this.useraccess.islivebookserviceaccess = user_access['0'].livebook_service_access
                this.useraccess.isprofnotesshowlivebook = user_access['0'].prof_notes_show_livebook
                this.useraccess.isprogram = user_access['0'].program         //program like tutor student and all
                this.useraccess.isroleid = user_access['0'].rl_id            // user roals id 1 2 3 ...
                this.useraccess.isuploadassignments = user_access['0'].upload_assignments
                this.useraccess.isworkshop = user_access['0'].workshop        // workshop name
                this.useraccess.view_notes = user_access['0'].view_notes        // to view note or not


                this.isAllowed = this.useraccess.isaddreflection;

                this.introduction = this.domSanitizer.bypassSecurityTrustHtml('<style>#maincontent  ul.key-questions {padding:0px} ul.key-questions li span.number {color:black !important; padding-right: 8px;} ul.key-questions li {padding-bottom: 0px !important;} ul{margin-bottom:0px !important}</style>');
            })
        })
    }

    onReflectionInput(i: number, ref: any) {
        this.dirtyRefs[i] = ref;
        this.retryCounts[i] = 0;
        this.saveStatuses[i] = 'saving';
        clearTimeout(this.savedTimeouts[i]);
        if (!this.saveSubjects[i]) {
            this.saveSubjects[i] = new Subject<any>();
            const sub = this.saveSubjects[i].pipe(
                debounceTime(1000),
                tap(() => {
                    this.saveStatuses[i] = 'saving';
                    clearTimeout(this.savedTimeouts[i]);
                }),
                switchMap((r) => {
                    return this.httpclient.post(this.shared.api + 'auth/insert_reflection', {
                        token: this.token,
                        page_id: r.pid,
                        reflection_text: r.reflection_text,
                        chapter_id: r.fk_chapter_id,
                        service_id: r.fk_service_id,
                        module_id: r.fk_module_id,
                        cluster_id: r.fk_cluster_id,
                        allow_student: r.reflection
                    }).pipe(
                        catchError(() => {
                            this.retryCounts[i] = (this.retryCounts[i] || 0) + 1;
                            if (this.retryCounts[i] < ReflectionsComponent.MAX_RETRIES) {
                                this.saveStatuses[i] = 'error';
                                this.retryTimeouts[i] = setTimeout(() => this.saveSubjects[i].next(r), 3000);
                            } else {
                                this.saveStatuses[i] = 'error';
                            }
                            return of(null);
                        })
                    );
                })
            ).subscribe((data: reflectiontext) => {
                if (data) {
                    this.retryCounts[i] = 0;
                    delete this.dirtyRefs[i];
                    this.saveStatuses[i] = 'saved';
                    this.savedTimeouts[i] = setTimeout(() => this.saveStatuses[i] = 'idle', 3000);
                }
            });
            this.saveSubscriptions.push(sub);
        }
        this.saveSubjects[i].next(ref);
    }

    private sendViaBeacon(ref: any) {
        if (!this.token || !ref) return;
        const formData = new FormData();
        formData.append('token', this.token);
        formData.append('page_id', ref.pid);
        formData.append('reflection_text', ref.reflection_text || '');
        formData.append('chapter_id', ref.fk_chapter_id);
        formData.append('service_id', ref.fk_service_id);
        formData.append('module_id', ref.fk_module_id);
        formData.append('cluster_id', ref.fk_cluster_id);
        formData.append('allow_student', ref.reflection);
        navigator.sendBeacon(this.shared.api + 'auth/insert_reflection?token=' + this.token, formData);
    }

    ngOnDestroy() {
        Object.keys(this.savedTimeouts).forEach(k => clearTimeout(this.savedTimeouts[k]));
        Object.keys(this.retryTimeouts).forEach(k => clearTimeout(this.retryTimeouts[k]));
        this.saveSubscriptions.forEach(s => s.unsubscribe());
        Object.keys(this.dirtyRefs).forEach(k => this.sendViaBeacon(this.dirtyRefs[k]));
    }
}

export interface reflection_interface {
    data: any;
}

export interface reflectiontext {
    status: any;
    message: any;
}

export interface userroalaccess {
    role: any;
}